import React from "react";
import about from "../../assets/image/nha.png";
const Terms_Condition = () => {
  const userData = JSON.parse(localStorage.getItem("selectedIndex"));

  return (
    <div className="container my-5">
      <div className="bg-white border rounded p-4 shadow">
        {/* Header */}
        <div className="border-bottom pb-3 mb-4 d-flex justify-content-between align-items-start">
          <h3 className="mb-0">User Consent (As per NHA)</h3>

          <img src={about} alt="NHA Logo" className="nha-logo" />
        </div>

        {/* Consent Text */}
        <div className="text-justify" style={{ lineHeight: "1.8" }}>
          <p>I hereby declare that:</p>

          <p>
            I am voluntarily sharing my Aadhaar Number / Virtual ID issued by
            the Unique Identification Authority of India (
            <strong>"UIDAI"</strong>), and my demographic information for the
            purpose of creating an Ayushman Bharat Health Account number (
            <strong>"ABHA Number"</strong>) and Ayushman Bharat Health Account
            address (<strong>"ABHA Address"</strong>). I authorize NHA to use my
            Aadhaar number / Virtual ID for performing Aadhaar based
            authentication with UIDAI as per the provisions of the Aadhaar
            (Targeted Delivery of Financial and other Subsidies, Benefits and
            Services) Act, 2016 for the aforesaid purpose. I understand that
            UIDAI will share my e-KYC details, or response of “Yes” with NHA
            upon successful authentication.
          </p>

          <p>
            I intend to create Ayushman Bharat Health Account Number (
            <strong>"ABHA Number"</strong>) and Ayushman Bharat Health Account
            address (<strong>"ABHA Address"</strong>) using document other than
            Aadhaar. (Click here to proceed further)
          </p>

          <p>
            I consent to usage of my ABHA address and ABHA number for linking of
            my legacy (past) health records and those which will be
            generated during this encounter.
          </p>

          <p>
            I authorize the sharing of all my health records with healthcare
            provider(s) for the purpose of providing healthcare services to me
            during this encounter.
          </p>

          <p>
            I consent to the anonymization and subsequent use of my
            health records for public health purposes.
          </p>

          <p>
            I <strong>PathKindLabs</strong> confirm that I have duly informed
            and explained the beneficiary of the contents of consent for
            aforementioned purposes.
          </p>

          <p>
            I <strong>{userData?.fullname}</strong> have been explained about the
            consent as stated above and hereby provide my consent for the
            aforementioned purposes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms_Condition;
